import HoardingBoard from "./HoardingBoard";
import ShareFeedBack from "./ShareFeedback";
import RaiseQuery from "./RaiseQuery";

const QueriesFeedBack = () => {
  return (
    <div className="">
      <HoardingBoard />
      <RaiseQuery />
      <ShareFeedBack />
    </div>
  );
};

export default QueriesFeedBack;
